import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';

export function SharedPain() {
    return (
        <section className="bg-navy-900 py-24 md:py-32" data-testid="shared-pain-section">
            <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center">
                <motion.div {...fadeUp}>
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-white mb-6 tracking-tight">
                        Different Businesses. Same Breaking Point.
                    </h2>
                    <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
                        <p>
                            Whether you're a solo agent doing $25M or a team doing $100M, the pain looks the same from the inside. You work too much. You net less than you should. You know you need help but haven't found a version of it you can trust. You've tried things that didn't work and drawn conclusions that aren't quite right.
                        </p>
                        <p>
                            The problem was never delegation. It was the absence of a system around it.
                        </p>
                        <p className="text-white font-montserrat font-bold text-xl">
                            That's what we fix.
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
